<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-navigator";

	import model from "../../stores/modelStore";
	import registrationList from "../../stores/registrationListStore";
	import { projectSettings } from "../../config";

	import { registerSubmit } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import PrimaryButton from "../../components/buttons/PrimaryButton.svelte";

	import ReturnedRegistrationList from "./components/ReturnedRegistrationList.svelte";

	export let pageTitle = null;

	document.title = pageTitle;
	$model.lastPageVisited = "ThankYou";

	window.onbeforeunload = null;

	onMount(() => registerSubmit($model.contact.emailAddress, $model.contact.phoneNumber, $model.registrationNumber));

	const startNewRegistration = async (e) => {
		e.preventDefault();

		let resp = await fetch("/api/registration");
		if (resp.ok) {
			let data = await resp.json();

			$model.surveyComplete = false;
			$model.parentRegistrationNumber = $model.parentRegistrationNumber || $model.registrationNumber;
			$model.registrationNumber = data.registrationNumber;
			$model.registrationToken = data.registrationToken;
			$model.registrationType = null;
			$model.hasBankAccount = null;
			$model.hasAdditionalInformation = null;
			$model.additionalInformation = null;
			$model.agreeToAdministratorInformation = null;
			$model.promiseInformationTrue = null;
			$model.consentToAcceptance = null;
			$model.verbalConfirmationGiven = null;
			$model.claimantSignature = null;
			$model.LastPageVisited = null;
			$model.claimDetails = {
				dateOfBirth: $model.claimDetails.dateOfBirth,
				placeOfBirth: $model.claimDetails.placeOfBirth,
				postalAddressDifferent: $model.claimDetails.postalAddressDifferent,
				skinName: $model.claimDetails.skinName,
				mother: $model.claimDetails.mother,
				father: $model.claimDetails.father,
				siblings: $model.claimDetails.siblings,
				hasOtherNames: $model.claimDetails.hasOtherNames,
				isAboriginalTorresStraitIslander: $model.claimDetails.isAboriginalTorresStraitIslander,
				englishLanguage: $model.claimDetails.englishLanguage,
				otherLanguage: $model.claimDetails.otherLanguage,
				laguange: $model.claimDetails.laguange,
				community: $model.claimDetails.community,
				workedInNTBetweenDates: null,
				littleOrNoWages: null,
				howKnowWorkInformationOther: null,
				haveWorkRecords: null,
				employment: [],
				knowledgeOfWork: [],
				deceased: {
					otherNames: []
				}
			};
			$model.spouseClaim = {
				souseChildren: [],
				claimantChildren: []
			};
			$model.parentClaim = {};
			$model.bankDetails = {};

			$model.photoIdDocumentList = [];
			$model.otherIdDocumentList = [];
			$model.workRecordsDocumentList = [];
			$model.parentIdDocumentList = [];
			$model.parentWorkRecordsDocumentList = [];
			$model.spouseIdDocumentList = [];
			$model.spouseWorkRecordsDocumentList = [];

			console.log("$model", $model);

			navigate("/SettlementRegistration/PersonalDetails");
		}
	};
</script>

<PageSection>
	<FormRowColumn rowClass="justify-content-center">
		<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		<h2 class="text-center">
			Thank you for completing your registration form for the {@html projectSettings.classActionName}.
		</h2>
	</FormRowColumn>

	<FormRowColumn>
		<h3>Your reference number</h3>
		<div class="box">{$model.registrationNumber}</div>
	</FormRowColumn>

	{#if $model.settlementRegistrationType == "Returning Registration"}
		<ReturnedRegistrationList />
	{:else}
		<FormRowColumn>
			<h3>Add another claim</h3>
			<div class="btn-wrap">
				<PrimaryButton class="btn-page-nav" type="submit" on:click={startNewRegistration}>
					I would like to complete another registration form to add another claim
				</PrimaryButton>
			</div>
		</FormRowColumn>
	{/if}

	<FormRowColumn>
		<p>
			If you have any questions, please contact Shine Lawyers on
			<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress></ClassActionEmailAddress>
			and quote the registration number above.
		</p>
	</FormRowColumn>
</PageSection>

<style>
	.box {
		background-color: var(--color-white);
		border: solid 1px var(--color-border);
		border-radius: 1px;
		padding: var(--spacing-sm);
		transition: var(--transition-fast);
		height: 50px;
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
	}

	.btn-wrap {
		display: flex;
		justify-content: center;
		margin-top: 12px;
	}
</style>
